<template>
  <strong class="level-desing level-badge" :class="toneClass">{{ level }}</strong>
</template>

<script>
import { getOnDemandLevelTone } from '@/utils/onDemandLevelTones';

const TONE_CLASS_PREFIX = 'level-badge--';

export default {
  name: 'LevelBadge',
  props: {
    level: { type: String, required: true }
  },
  computed: {
    toneClass() {
      const tone = getOnDemandLevelTone(this.level);

      return tone ? `${TONE_CLASS_PREFIX}${tone}` : '';
    }
  }
};
</script>

<style lang="scss" scoped>
.level-badge {
  color: #676769;
  background: #f4f4f4;
}
.level-badge--good {
  color: #1aae6f;
  background: #b0eed3;
}
.level-badge--warning {
  color: #f2a000;
  background: #fdf5cf;
}
.level-badge--bad {
  color: #f80031;
  background: #fdd1da;
}
</style>
